<div class="content">
    <div class="main-action-col">
        <div style="padding-left: 15px; padding-right: 15px; margin-left: auto; margin-right: auto;">
            <div class="row">
                <div class="col-sm-5">
                    <h2 class="title" id="mycolor">Dashboard</h2>
                </div>

            </div>
        </div>
    </div>
    <div class="dashboard-block">
        <div class="container">
            <div class="row">
                <div class="cardblock-ui-list">
                    <div class="col-md-2">

                    </div>
                    <ul>

                        <!-- <li>
                            <a routerLink="/dashboard" style="text-decoration:none">
                                <div class="cardblock-ui">
                                    <div class="icon">
                                        <i class="fa fa-dashboard fa-4x" style="color:#004a6f"></i>
                                    </div>
                                    <div class="">
                                        <h3>Dashboard</h3>
                                    </div>

                                </div>
                            </a>
                        </li> -->
                        <li *ngIf="viewMonitos">
                            <a style="text-decoration:none" routerLink="/monitors">
                                <div class="cardblock-ui">
                                    <div class="icon">
                                        <svg viewBox="0 0 120.71 121.95">
                                            <g data-name="Group 2" transform="translate(-92.391 -42.12)">
                                                <path id="Path_2" data-name="Path 2"
                                                    d="M108.949,115.066l-.04,47.26a2.878,2.878,0,0,0,3.653,1.554,3.052,3.052,0,0,0,1.868-3.654l-.161-13.882,14.654-.042a11.246,11.246,0,0,0,7.749-.3,11.674,11.674,0,0,0,6.808-13.642l5.707-15.563,32.637,13.879a6.784,6.784,0,0,0,8.678-3.5l1.45-3.41,5.358,2.279a6.784,6.784,0,0,0,8.679-3.5l6.525-15.344a6.331,6.331,0,0,0-3.43-8.5l-5.358-2.279.415-.974c-.07-.174.1-.244.033-.417l6.59-4.676a4.718,4.718,0,0,0,1.864-4.384,5.291,5.291,0,0,0-2.791-3.919L117.844,43.072a12.2,12.2,0,0,0-15.968,6.439l-7.595,18.2a4.105,4.105,0,0,0-.025,3.441,4.51,4.51,0,0,0,2.475,2.634l1.115.761L92.977,85.991A6.331,6.331,0,0,0,96.406,94.5l37.508,15.951-5.085,14.1-.521.21a11.154,11.154,0,0,0-6.274,5.96l-7.986.077.282-17.9a2.878,2.878,0,0,0-3.653-1.554A3.2,3.2,0,0,0,108.949,115.066Zm97.079-28.453-23.549,17.164a1.4,1.4,0,0,1-.938.176l-81.9-34.975,7.354-17.293a6.91,6.91,0,0,1,8.678-3.5Zm-11.9,32.04,3.418-8.038,3.832-9.012,5.358,2.279a.9.9,0,0,1,.49,1.215L200.7,120.442a.905.905,0,0,1-1.215.49Zm-45.2-8.006h0L138.7,106.3h0L98.512,89.207a.9.9,0,0,1-.49-1.215l4.868-11.447,76.477,32.523a7.383,7.383,0,0,0,5.039-.014,4.643,4.643,0,0,0,1.319-.733l9.711-6.943-3.107,7.307-5.593,13.152h0l-1.45,3.41a.9.9,0,0,1-1.215.49Zm-4.784,4.149-4.153,11.91a13.16,13.16,0,0,0-5.011-2.418l4.05-11.666Zm-9.256,26.277a5.994,5.994,0,0,1-7.62-3.384,5.8,5.8,0,1,1,10.761-4.339A6.124,6.124,0,0,1,134.887,141.073ZM114.3,142.5l-.039-5.554,6.922.17a11.017,11.017,0,0,0,.633,2.569A10.586,10.586,0,0,0,123.6,142.6Z"
                                                    transform="translate(0 0)" fill="#004a6f"></path>
                                            </g>
                                        </svg>
                                    </div>
                                    <div class="">
                                        <h3>Devices</h3>
                                    </div>

                                </div>
                            </a>
                        </li>
                        <li *ngIf="viewSites">
                            <a style="text-decoration:none" routerLink="/sites">
                                <div class="cardblock-ui">
                                    <div class="icon">
                                        <i class="fa fa-leaf fa-4x" style="color:#004a6f"></i>
                                    </div>
                                    <div class="">
                                        <h3>Sites</h3>
                                    </div>

                                </div>
                            </a>
                        </li>
                        <!-- <li>
                            <a style="text-decoration:none" routerLink="/user-management">
                                <div class="cardblock-ui">
                                    <div class="icon">
                                        <i class="fa fa-user fa-4x" style="color:#004a6f"></i>
                                    </div>
                                    <div class="">
                                        <h3>User Management</h3>
                                    </div>
                                </div>
                            </a>
                        </li> -->
                        <li *ngIf="viewSettings">
                            <a style="text-decoration:none" routerLink="/user-management">
                                <div class="cardblock-ui">
                                    <div class="icon">
                                        <i class="fa fa-cog fa-4x" style="color:#004a6f"></i>
                                    </div>
                                    <div class="">
                                        <h3>Settings</h3>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

    </div>
</div>

